import React, {Fragment} from "react";
import {getAttribute} from "../../FormEdit/FormEditReducerHelpers";
import {Question, RadiusInputHover, RequireText} from "../Base/BaseStyles";

export function InputNumberHover({component_key, attributes, dispatch}) {
  const title = getAttribute("title", attributes);
  const question = getAttribute("question", attributes);
  const require = getAttribute("require", attributes);
  const require_text = getAttribute("require_text", attributes);
  return (
    <Fragment>
      <div className={"row"}>
        <div className={"col-12"}>
          <Question>{question}</Question>
        </div>
        <div className={"col-12"}>
          <RadiusInputHover
            type="number"
            className="form-control"
            aria-label=""
            placeholder="Enter number"
            value={title}
            onChange={(event) =>
              dispatch({
                type: "input_number_title_change",
                title: event.target.value,
                key: component_key,
              })
            }
          />
        </div>
        {require === "true" && !title ? (
          <RequireText>{require_text}</RequireText>
        ) : (
          <div></div>
        )}
      </div>
    </Fragment>
  );
}

export default InputNumberHover;
